import React from 'react';
import classes from './Spinner.module.css';

const spinner = (props) => {
  const loaderClasses = [classes.Loader];
  if (props.lightColor === true) loaderClasses.push(classes.LightColor);
  if (props.small === true) loaderClasses.push(classes.Small);
  if (props.className) loaderClasses.push(props.className);
  return <div className={loaderClasses.join(' ')}>Loading...</div>;
};

export default spinner;
